import { LOADING_PDF, LOADED_PDF, LOAD_PDF_FAILED } from '../actions/types';

export default function loadingState(state = LOADING_PDF, action = {}) {
  switch (action.type) {
    case LOADING_PDF:
    case LOADED_PDF:
    case LOAD_PDF_FAILED:
      return action.type;
    default:
      return state;
  }
}
